import { gu2px, useTheme } from '@uds/theme-utils';
import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import { useBreakpoints } from '@ux/responsive';

export default ({ first, last }: { first: boolean; last: boolean }) => {
  const {
    theme: { spacing },
  } = useTheme();
  const { isMinLg } = useBreakpoints();
  return useStyles(
    {
      default: {
        cell: {
          ...cssSides('padding', Side.X, gu2px(1.5, spacing)),
        },
      },

      firstChild: {
        cell: {
          paddingLeft: gu2px(3, spacing),
        },
      },
      lastChild: {
        cell: {
          paddingRight: gu2px(3, spacing),
        },
      },

      isMinLg: {
        cell: {
          ...cssSides('padding', Side.X, gu2px(2, spacing)),
        },
      },

      firstChildLg: {
        cell: {
          paddingLeft: gu2px(4, spacing),
        },
      },

      lastChildLg: {
        cell: {
          paddingRight: gu2px(4, spacing),
        },
      },
    },
    [
      { isMinLg: isMinLg },
      { firstChild: first },
      { lastChild: last },
      { firstChildLg: first && isMinLg },
      { lastChildLg: last && isMinLg },
    ],
  );
};
